import {SocketClient} from "cbcore-ts"
import {IF, IS, IS_NOT, nil, NO, UIButton, UIColor, UIRoute, UITextView, UIView, UIViewController, YES} from "uicore-ts"
import {CBDialogViewShower} from "./Custom components/CB/CBDialogViewShower"
import {RHCore} from "./Core/RHCore"
// import { RHPhoneNumberValidation } from "./Custom components/RH/Utils_slop/RHPhoneNumberValidation"
import {RHUserPasswordPolicy} from "./Core/RHUserPasswordPolicy"
import {RHFocusManager} from "./Custom components/RH/Keyboard navigation/RHFocusManager"
import {RHPageFocusManager} from "./Custom components/RH/Keyboard navigation/RHPageFocusManager"
import {RHAlertBannerView} from "./Custom components/RH/RHAlertBannerView"
import {RHButton} from "./Custom components/RH/RHButton"
import {RHColor} from "./Custom components/RH/RHColor"
import {RHPanelView} from "./Custom components/RH/RHPanelView"
import {RHTextField} from "./Custom components/RH/RHTextField"
import {RHColors, RHDialogs, RHFont, RHForms, RHSpacing} from "./Custom components/RH/Utils_slop/RHDesignTokens"
import {UserMainViewController} from "./UserMain/UserMainViewController"
import {RHUserName, RHUserNameComponents} from "./Core/RHUserName"
import {RHUserNameInputView} from "./Custom components/RH/RHUserNameInputView"
import {RHTextSanitizer} from "./Custom components/RH/Utils_slop/RHTextSanitizer"


export class UserProfileViewController extends UIViewController {

    static override readonly routeComponentName = "profile"

    static override readonly ParameterIdentifierName = { focusName: "focusName" }

    _savedNameComponents: RHUserNameComponents = { firstName: "", lastName: "" }
    // _savedPhoneNumberText = ""

    readonly personalInformationPanelView = new RHPanelView().addedAsSubviewToView(this.view)

    readonly passwordPanelView = new RHPanelView().addedAsSubviewToView(this.view)

    readonly personalInformationTitleLabel = new UITextView(nil, UITextView.type.header4).configuredWithObject({
        text: "Isikuandmed",
        textColor: RHColors.textPrimary,
        isSingleLine: NO
    }).addedAsSubviewToView(this.view)

    readonly personalInformationExplanationLabel = new UITextView().configuredWithObject({
        text: "Siin saad muuta oma nime ja vaadata e-posti aadressi.",
        textColor: RHColors.textSecondary,
        isSingleLine: NO
    }).addedAsSubviewToView(this.view)

    readonly passwordExplanationLabel = new UITextView().configuredWithObject({
        text: "Siin saad muuta oma salasõna.",
        textColor: RHColors.textSecondary,
        isSingleLine: NO
    }).addedAsSubviewToView(this.view)

    readonly forcedChangeBannerView = new RHAlertBannerView().configuredWithObject({
        alertType: RHAlertBannerView.type.Warning,
        text: "Sulle saadeti ajutine salasõna. Enne jätkamist tuleb see uue salasõnaga asendada.",
        hidden: YES
    })

    readonly nameInputView = new RHUserNameInputView().configuredWithObject({
        lastNameTextField: {
            controlEventTargetAccumulator: {
                EnterDown: (_sender, event) => {
                    this.saveNameAndPhoneNumberButton.sendControlEventForKey(UIButton.controlEvent.EnterDown, event)
                }
            }
        }
    }).addedAsSubviewToView(this.view)

    readonly previousNameLabel = new UITextView().configuredWithObject({
        textColor: RHColors.textSecondary,
        isSingleLine: NO,
        style: { overflowWrap: "anywhere" }
    })

    readonly missingNameBannerView = new RHAlertBannerView().configuredWithObject({
        alertType: RHAlertBannerView.type.Warning,
        text: "Nime sisestamine on kohustuslik",
        textAlignment: UITextView.textAlignment.center
    })

    // Phone number handling is commented out until we actually need it. If we do, it must be encrypted before being stored.
    // readonly phoneNumberTextField = new RHTextField().addedAsSubviewToView(this.view).configuredWithObject({
    //     placeholderText: "Telefoninumber",
    //     type: "tel",
    //     controlEventTargetAccumulator: {
    //         EnterDown: (sender, event) => {
    //             this.saveNameAndPhoneNumberButton.sendControlEventForKey(UIButton.controlEvent.EnterDown, event)
    //         },
    //         TextChange: () => {
    //             this.phoneNumberTextField.resetValidationVisuals()
    //         }
    //     }
    // })

    readonly saveNameAndPhoneNumberButton = new RHButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: {
            text: "Salvesta",
            style: { fontSize: RHDialogs.questionFooterButtonFontSize }
        },
        variant: "success",
        contentPadding: RHDialogs.questionFooterButtonContentPadding,
        controlEventTargetAccumulator: {
            PrimaryActionTriggered: async () => {
                await this._submitNameAndPhoneNumberChange()
            }
        }
    })

    readonly emailLabel = new UITextView().configuredWithObject({
        backgroundColor: UIColor.transparentColor,
        textColor: RHColors.textPrimary,
        isSingleLine: NO,
        style: {
            fontFamily: RHFont.familyBase,
            fontSize: RHFont.sizeMedium,
            fontWeight: RHFont.weightRegular,
            lineHeight: RHFont.lineHeightBase,
            overflowWrap: "anywhere"
        }
    }).addedAsSubviewToView(this.view)

    readonly passwordSectionTitleLabel = new UITextView(
        this.view.elementID + "PasswordSectionTitleLabel",
        UITextView.type.header4
    ).configuredWithObject({
        text: "Salasõna muutmine",
        backgroundColor: UIColor.transparentColor,
        textColor: RHColors.textPrimary,
        isSingleLine: NO
    }).addedAsSubviewToView(this.view)

    readonly statusBannerView = new RHAlertBannerView()

    readonly currentPasswordTextField = new RHTextField().addedAsSubviewToView(this.view).configuredWithObject({
        placeholderText: "Praegune salasõna",
        type: "password",
        autocompleteEnabled: NO,
        controlEventTargetAccumulator: {
            EnterDown: () => {
                this.newPasswordTextField.focus()
            }
        }
    })

    readonly newPasswordTextField = new RHTextField().addedAsSubviewToView(this.view).configuredWithObject({
        placeholderText: "Uus salasõna",
        type: "password",
        autocompleteEnabled: NO,
        controlEventTargetAccumulator: {
            EnterDown: () => {
                this.confirmPasswordTextField.focus()
            }
        }
    })

    readonly passwordRequirementsLabel = new UITextView(
        this.view.elementID + "PasswordRequirementsLabel",
        UITextView.type.span
    ).configuredWithObject({
        text: RHUserPasswordPolicy.minimumLengthRequirementMessage(),
        backgroundColor: UIColor.transparentColor,
        textColor: RHColors.textSecondary,
        isSingleLine: NO,
        style: {
            fontSize: RHFont.sizeXSmall
        }
    }).addedAsSubviewToView(this.view)

    readonly confirmPasswordTextField = new RHTextField().addedAsSubviewToView(this.view).configuredWithObject({
        placeholderText: "Korda uut salasõna",
        type: "password",
        autocompleteEnabled: NO,
        controlEventTargetAccumulator: {
            EnterDown: (sender, event) => {
                this.changePasswordButton.sendControlEventForKey(UIButton.controlEvent.EnterDown, event)
            }
        }
    })

    readonly changePasswordButton = new RHButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: {
            text: "Muuda salasõna",
            style: { fontSize: RHDialogs.questionFooterButtonFontSize }
        },
        variant: "success",
        contentPadding: RHDialogs.questionFooterButtonContentPadding,
        controlEventTargetAccumulator: {
            PrimaryActionTriggered: async () => {
                await this._submitPasswordChange()
            }
        }
    })

    override _focusManager = new RHFocusManager(() => [
        this.nameInputView.firstNameTextField,
        this.nameInputView.lastNameTextField,
        // this.phoneNumberTextField,
        this.saveNameAndPhoneNumberButton,
        this.currentPasswordTextField,
        this.newPasswordTextField,
        this.confirmPasswordTextField,
        this.changePasswordButton
    ])


    constructor(view: UIView) {

        super(view)

        this.view.configureWithObject({
            backgroundColor: RHColor.backgroundColor
        })

    }


    override async viewWillAppear() {

        await super.viewWillAppear()

        RHPageFocusManager.shared.registerContentControllerManager(this._focusManager)
        this._updateProfileInfo()

        if (UIRoute.currentRoute.componentWithViewController(UserProfileViewController)?.parameters.focusName === "YES") {
            this.nameInputView.firstNameTextField.focus()
        }

    }


    override async viewWillDisappear() {

        await super.viewWillDisappear()

        RHPageFocusManager.shared.deregisterContentControllerManager(this._focusManager)
        // This controller has no deleteOnUnload, so it survives navigation -
        // an unsubmitted password left typed in these fields would otherwise
        // still be sitting there next time the screen appears.
        this._clearPasswordFields()

    }


    override async handleRoute(route: UIRoute) {

        await super.handleRoute(route)

        this._updateProfileInfo()

        if (route.componentWithViewController(UserProfileViewController)?.parameters.focusName === "YES") {
            this.nameInputView.firstNameTextField.focus()
        }

    }


    _updateProfileInfo() {

        const userProfile = RHCore.sharedInstance.userProfile
        const isPasswordChangeRequired = !!userProfile?.isPasswordChangeRequired

        const contactInformation = userProfile?.contactInformation
        this.nameInputView.nameComponents = {
            firstName: contactInformation?.firstName ?? "",
            lastName: contactInformation?.lastName ?? ""
        }
        this.nameInputView.firstNameTextField.enabled = !isPasswordChangeRequired
        this.nameInputView.lastNameTextField.enabled = !isPasswordChangeRequired
        const previousName = contactInformation?.name?.trim() ?? ""
        if (previousName && previousName.toLowerCase() !== userProfile?.email.toLowerCase() && !contactInformation?.firstName && !contactInformation?.lastName) {
            this.previousNameLabel.text = `Senine nimi: ${RHTextSanitizer.escapedHTML(previousName)}`
            this.previousNameLabel.addedAsSubviewToView(this.view)
        }
        else {
            this.previousNameLabel.removeFromSuperview()
        }
        // this.phoneNumberTextField.configureWithObject({
        //     text: userProfile?.contactInformation.phoneNumber ?? "",
        //     enabled: !isPasswordChangeRequired
        // })
        this.saveNameAndPhoneNumberButton.enabled = !isPasswordChangeRequired
        this._savedNameComponents = this.nameInputView.nameComponents
        // this._savedPhoneNumberText = this.phoneNumberTextField.text.trim()
        this.emailLabel.text = `E-post: ${userProfile?.email || "-"}`
        this.forcedChangeBannerView.hidden = !isPasswordChangeRequired
        if (isPasswordChangeRequired) {
            this.forcedChangeBannerView.addedAsSubviewToView(this.view)
        }
        else {
            this.forcedChangeBannerView.removeFromSuperview()
        }
        this.view.setNeedsLayoutUpToRootView()

    }


    async _submitNameAndPhoneNumberChange() {

        const userId = RHCore.sharedInstance.userProfile?._id
        if (!userId || !this.saveNameAndPhoneNumberButton.enabled) {
            return
        }

        const nameComponents = this.nameInputView.nameComponents
        const nameError = RHUserName.failedRequirementMessageForComponents(nameComponents)
        if (nameError) {
            CBDialogViewShower.alert(nameError)
            return
        }
        // const phoneNumber = this.phoneNumberTextField.text.trim()
        const contactChanges = nameComponents
        // if (phoneNumber !== this._savedPhoneNumberText) {
        //     if (!RHPhoneNumberValidation.isPhoneNumberValid(phoneNumber)) {
        //         this.phoneNumberTextField.isValid = NO
        //         CBDialogViewShower.alert(RHPhoneNumberValidation.formatRequirementMessage)
        //         return
        //     }
        //     contactChanges.phoneNumber = phoneNumber
        // }
        if (nameComponents.firstName === this._savedNameComponents.firstName &&
            nameComponents.lastName === this._savedNameComponents.lastName) {
            CBDialogViewShower.alert("Muudatusi ei ole.")
            return
        }

        this.saveNameAndPhoneNumberButton.enabled = NO
        this.nameInputView.firstNameTextField.enabled = NO
        this.nameInputView.lastNameTextField.enabled = NO
        // this.phoneNumberTextField.enabled = NO

        try {

            const response = await SocketClient.UpdateNameAndPhoneNumberForCurrentUser(contactChanges)
            if (RHCore.sharedInstance.userProfile?._id !== userId) {
                return
            }

            if (response.result?.ok) {
                const userProfile = RHCore.sharedInstance.userProfile
                if (userProfile) {
                    if (response.result.name !== undefined) {
                        userProfile.contactInformation = {
                            ...userProfile.contactInformation,
                            name: response.result.name,
                            firstName: response.result.firstName,
                            lastName: response.result.lastName
                        }
                        this.nameInputView.nameComponents = response.result
                        this._savedNameComponents = this.nameInputView.nameComponents
                        this.previousNameLabel.removeFromSuperview()
                        RHCore.sharedInstance.procurementStore.invalidateCompanyScopedCaches()
                    }
                    // if (response.result.phoneNumber !== undefined) {
                    //     userProfile.contactInformation.phoneNumber = response.result.phoneNumber
                    //     this.phoneNumberTextField.text = response.result.phoneNumber
                    //     this._savedPhoneNumberText = response.result.phoneNumber
                    // }
                }
                RHCore.sharedInstance.broadcastMessageInRootViewTree({
                    name: RHCore.broadcastEventName.userProfileDidChange
                })
                this.view.setNeedsLayoutUpToRootView()
                CBDialogViewShower.alert("Andmed on salvestatud.")
            }
            else {
                CBDialogViewShower.alert(
                    RHCore.sharedInstance.errorMessageFromResponse(response, "Andmete salvestamine ebaõnnestus.")
                    ?? "Andmete salvestamine ebaõnnestus."
                )
            }

        }
        catch (error) {
            console.error("Name and phone number update failed:", error)
            CBDialogViewShower.alert("Andmete salvestamine ebaõnnestus.")
        }
        finally {
            const isPasswordChangeRequired = !!RHCore.sharedInstance.userProfile?.isPasswordChangeRequired
            this.saveNameAndPhoneNumberButton.enabled = !isPasswordChangeRequired
            this.nameInputView.firstNameTextField.enabled = !isPasswordChangeRequired
            this.nameInputView.lastNameTextField.enabled = !isPasswordChangeRequired
            // this.phoneNumberTextField.enabled = !isPasswordChangeRequired
        }

    }


    async _submitPasswordChange() {

        const currentPassword = this.currentPasswordTextField.text
        const newPassword = this.newPasswordTextField.text
        const confirmPassword = this.confirmPasswordTextField.text

        if (!currentPassword) {
            this._showStatus("Palun sisesta praegune salasõna.")
            return
        }

        if (!RHUserPasswordPolicy.passwordMeetsMinimumLength(newPassword)) {
            CBDialogViewShower.alert(RHUserPasswordPolicy.minimumLengthRequirementMessage())
            return
        }

        if (!RHUserPasswordPolicy.passwordMeetsMaximumLength(newPassword)) {
            CBDialogViewShower.alert(RHUserPasswordPolicy.maximumLengthRequirementMessage())
            return
        }

        if (!RHUserPasswordPolicy.passwordAvoidsCommonPatterns(newPassword)) {
            CBDialogViewShower.alert(RHUserPasswordPolicy.commonPatternRequirementMessage())
            return
        }

        if (newPassword !== confirmPassword) {
            this._showStatus("Uued salasõnad ei kattu.")
            return
        }

        this.changePasswordButton.enabled = NO

        try {

            const wasPasswordChangeRequired = !!RHCore.sharedInstance.userProfile?.isPasswordChangeRequired

            const response = await SocketClient.ChangePasswordForCurrentUser({ currentPassword, newPassword })

            if (response.result?.ok) {

                const userProfile = RHCore.sharedInstance.userProfile
                if (userProfile) {
                    userProfile.isPasswordChangeRequired = NO
                }
                RHCore.sharedInstance.broadcastMessageInRootViewTree({
                    name: RHCore.broadcastEventName.userProfileDidChange
                })

                this._clearPasswordFields()
                this.statusBannerView.text = ""
                this._updateProfileInfo()

                CBDialogViewShower.alert("Salasõna on muudetud.")

                // Only a forced change (mailed temp password) leaves the profile
                // screen automatically - the user was blocked from the rest of
                // the app until this succeeded, so "done" means "enter the app".
                // A voluntary change from an already-normal session stays put.
                if (wasPasswordChangeRequired) {
                    UIRoute.currentRoute
                        .routeByRemovingComponentsOtherThanOnesNamed(["settings"])
                        .routeWithViewControllerComponent(UserMainViewController, nil)
                        .apply()
                }

            }
            else {
                this._showStatus(
                    RHCore.sharedInstance.errorMessageFromResponse(response, "Salasõna muutmine ebaõnnestus.")
                    ?? "Salasõna muutmine ebaõnnestus."
                )
            }

        }
        catch (error) {

            console.error("Password change failed:", error)
            this._showStatus("Salasõna muutmine ebaõnnestus.")

        }
        finally {
            this.changePasswordButton.enabled = YES
        }

    }


    _clearPasswordFields() {

        this.currentPasswordTextField.text = ""
        this.newPasswordTextField.text = ""
        this.confirmPasswordTextField.text = ""

    }


    _showStatus(message: string) {

        this.statusBannerView.configureWithObject({
            text: message,
            alertType: RHAlertBannerView.type.Error
        })
        this.view.setNeedsLayoutUpToRootView()

    }


    override layoutViewSubviews() {

        super.layoutViewSubviews()

        const userProfile = RHCore.sharedInstance.userProfile
        const savedName = userProfile?.contactInformation?.name?.trim() ?? ""
        if (!savedName || savedName.toLowerCase() === userProfile?.email.toLowerCase()) {
            this.missingNameBannerView.addedAsSubviewToView(this.view)
        }
        else {
            this.missingNameBannerView.removeFromSuperview()
        }

        if (IS(this.statusBannerView.text)) {
            this.statusBannerView.addedAsSubviewToView(this.view)
        }
        else {
            this.statusBannerView.removeFromSuperview()
        }

        // Canvas text measurement does not account for wrapping inside long names and email addresses.
        this.emailLabel.setUseFastMeasurement(NO)
        this.previousNameLabel.setUseFastMeasurement(NO)
        const padding = this.core.paddingLength
        const bounds = this.view.contentBoundsWithInset(padding * 2).rectangleWithMaxWidth(880 - padding * 2, 0.5)
        const actionButtonWidth = [
            [
                [
                    this.saveNameAndPhoneNumberButton.titleLabel.intrinsicContentWidth(
                        RHDialogs.questionFooterButtonHeight
                    ),
                    this.changePasswordButton.titleLabel.intrinsicContentWidth(
                        RHDialogs.questionFooterButtonHeight
                    )
                ].max() +
                RHDialogs.questionFooterButtonContentPadding * 2 +
                RHDialogs.questionFooterButtonTextSafetyBuffer,
                RHDialogs.questionFooterButtonMinWidth
            ].max(),
            RHDialogs.questionFooterButtonMaxWidth,
            bounds.width
        ].min()

        bounds
            .rectangleWithHeight(0)
            .IF(IS_NOT(this.forcedChangeBannerView.hidden))
            .rectangleWithHeight(this.forcedChangeBannerView)
            .assignedAsFrameOfView(this.forcedChangeBannerView)
            .rectangleForNextRow(RHSpacing.large + padding, 0)
            .ENDIF()
            .rectangleWithHeight(this.personalInformationTitleLabel)
            .assignedAsFrameOfView(this.personalInformationTitleLabel)
            .rectangleForNextRow(RHSpacing.small, this.personalInformationExplanationLabel)
            .assignedAsFrameOfView(this.personalInformationExplanationLabel)
            .rectangleForNextRow(RHSpacing.medium, this.emailLabel)
            .assignedAsFrameOfView(this.emailLabel)
            .IF(this.view.hasSubview(this.missingNameBannerView))
            .rectangleForNextRow(RHSpacing.medium, this.missingNameBannerView)
            .assignedAsFrameOfView(this.missingNameBannerView)
            .ENDIF()
            .IF(this.view.hasSubview(this.previousNameLabel))
            .rectangleForNextRow(RHSpacing.small, this.previousNameLabel)
            .assignedAsFrameOfView(this.previousNameLabel)
            .ENDIF()
            .rectangleForNextRow(RHSpacing.medium, this.nameInputView)
            .assignedAsFrameOfView(this.nameInputView)
            .rectangleForNextRow(RHSpacing.small, RHDialogs.questionFooterButtonHeight)
            .rectangleWithWidth(actionButtonWidth, 1)
            .assignedAsFrameOfView(this.saveNameAndPhoneNumberButton)
            .rectangleWithWidth(bounds.width, 1)
            .rectangleForNextRow(padding * 2 + RHSpacing.large, this.passwordSectionTitleLabel)
            .assignedAsFrameOfView(this.passwordSectionTitleLabel)
            .rectangleForNextRow(RHSpacing.small, this.passwordExplanationLabel)
            .assignedAsFrameOfView(this.passwordExplanationLabel)
            .IF(IS(this.statusBannerView.text))
            .rectangleForNextRow(RHSpacing.medium, this.statusBannerView)
            .assignedAsFrameOfView(this.statusBannerView)
            .ENDIF()
            .rectangleForNextRow(RHSpacing.medium, RHForms.fieldSingleLineFieldHeight)
            .assignedAsFrameOfView(this.currentPasswordTextField)
            .rectangleForNextRow(RHSpacing.small, RHForms.fieldSingleLineFieldHeight)
            .assignedAsFrameOfView(this.newPasswordTextField)
            .rectangleForNextRow(RHSpacing.tiny, this.passwordRequirementsLabel)
            .assignedAsFrameOfView(this.passwordRequirementsLabel)
            .rectangleForNextRow(RHSpacing.small, RHForms.fieldSingleLineFieldHeight)
            .assignedAsFrameOfView(this.confirmPasswordTextField)
            .rectangleForNextRow(RHSpacing.medium, RHDialogs.questionFooterButtonHeight)
            .rectangleWithWidth(actionButtonWidth, 1)
            .assignedAsFrameOfView(this.changePasswordButton)

        this.personalInformationPanelView.weakFrame = [
            this.personalInformationTitleLabel.frame,
            this.saveNameAndPhoneNumberButton.frame
        ].boundingBox().rectangleWithInset(-padding)
        this.passwordPanelView.weakFrame = [
            this.passwordSectionTitleLabel.frame,
            this.changePasswordButton.frame
        ].boundingBox().rectangleWithInset(-padding)

    }

}
